import { FunctionComponent, useState } from 'react';
import { useAtom } from 'jotai';

import { fetch_one } from '../../lib/server_helper';
import { loginAtom } from '../../lib/auth';

import {
  Grid,
} from '@mui/material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import {
  Page,
  StyledButton,
  StyledDropzone,
  Typography
} from '../../components/interface';

import { AlertEmailSent } from '../../components/alerts/EmailSent';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import { Export } from '../../models/Export';

type PlatformPain2ExcelProps = {};

export const PlatformPain2Excel: FunctionComponent<PlatformPain2ExcelProps> = () => {
  const [login] = useAtom(loginAtom);
  const [items, setItems] = useState<File[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [emailSentSnackOpen, setEmailSentSnackOpen] = useState<boolean>(false);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);

  const doConvert = () => {
    if (items.length === 0) return;

    setLoader(true);

    let formData = new FormData();
    formData.append('object', 'export');
    formData.append('class_action', 'custom_api_convert_pain');
    formData.append('ob[fake_field]', '');

    formData.append('item', items[0]);

    fetch_one<Export>('/nl/v3/objects/custom_action', formData, (obs, complete_data) => {
      setLoader(false);
      setItems([]);
      setEmailSentSnackOpen(true);
    }, (z) => {
      setLoader(false);
      setServerErrorSnackOpen(true);
    }, login);
  };

  return (
    <Page sx={{}} title="Pain to Excel" helper="pain_files">
      <Grid container spacing={2} sx={{maxWidth: 800}}>
        <Grid item xs={12}>
          <Typography sx={{marginBottom: 1}}>
            Upload a PAIN.001.001.03 file (.txt) and the converted Excel sheet will be emailed to you.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <StyledDropzone
            acceptedFiles={{
              'text/plain': [],
              'text/xml': [],
              'application/xml': []
            }}
            onDrop={acceptedFiles => {setItems(acceptedFiles);}}
            multiple={false}
            maxSize={25 * 1000 * 1000}
            items={items}
            dropText="Click/Drop"
            dropHint="PAIN .txt file, < 25mb"
          />
        </Grid>
        <Grid item xs={12}>
          <StyledButton
            label="Convert"
            id='convert'
            contained
            loading={loader}
            disabled={items.length === 0}
            onClick={() => {
              doConvert();
            }}
            sx={{marginRight: 3}}
            startIcon={<CloudUploadIcon />}
          />
        </Grid>
      </Grid>

      {!!emailSentSnackOpen && <AlertEmailSent open={emailSentSnackOpen} setOpen={(b) => {setEmailSentSnackOpen(b);}} />}
      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
    </Page>
  );
};
